import { Fragment } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Typography, useTheme } from "@mui/material";

import { TooltipInfoBox } from "../../components/design-system/TooltipInfoBox.js";

export function WorkItemStatusBox({
  headingText,
  mainText,
  backgroundColor,
  color,
  align,
  hideHeadingText,
  tooltip,
  singleLine,
}: {
  headingText: string;
  mainText: string | string[];
  backgroundColor: string;
  color: string;
  align?: "flex-start" | "flex-end";
  hideHeadingText?: boolean;
  tooltip?: string;
  // Opt-in: keeps the pill's text on one line. Off by default because some
  // callers pass free-text (e.g. names, emails) that must be allowed to wrap.
  singleLine?: boolean;
}) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {!hideHeadingText && (
        <Typography
          sx={{
            fontSize: theme.spacing(1.625),
            color: theme.palette.primary.hint,
            marginBottom: theme.spacing(0.5),
            justifyContent: align || "flex-start",
            display: "flex",
          }}
        >
          {headingText}
        </Typography>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            padding: theme.spacing(0.75),
            borderRadius: "6px",
            backgroundColor,
            color,
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(0.5),
          }}
        >
          <Typography
            sx={{
              fontSize: theme.spacing(1.625),
              backgroundColor,
              whiteSpace: singleLine ? "nowrap" : undefined,
            }}
          >
            {typeof mainText === "string"
              ? mainText
              : mainText.map((t, i) => (
                  <Fragment key={i}>
                    {t}
                    <br />
                  </Fragment>
                ))}
          </Typography>
          {tooltip && (
            <TooltipInfoBox
              title={tooltip}
              icon={
                <InfoOutlinedIcon
                  fontSize="small"
                  sx={{ color, display: "block" }}
                />
              }
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}
